import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import Actions from './actions';
var Types = Actions.Types;
var INITIAL_STATE = {
  err: {},
  isError: false,
  code1: undefined,
  code2: undefined,
  isLoading: false,
  check: undefined,
  originalCheck: undefined,
  receipt: undefined,
  payload: undefined,
  Gratuity: 0.00,
  NetAmountWithNoTax: undefined,
  OrderLines: undefined,
  Success: undefined,
  Tax: undefined,
  PreCheck: undefined,
  TotalToPay: undefined,
  location: undefined,
  isLocationLoading: false,
  OrderId: undefined,
  paymentMethod: undefined
};

var mobilepayReducer = function mobilepayReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Types.SET_RECEIPT_CODE:
      {
        var code1 = action.code1,
            code2 = action.code2;
        return _objectSpread(_objectSpread({}, state), {}, {
          code1: code1,
          code2: code2 === null || code2 === void 0 ? void 0 : code2.toLowerCase(),
          check: undefined
        });
      }

    case Types.SET_IS_LOADING:
      {
        var isLoading = action.isLoading;
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: isLoading
        });
      }

    case Types.SET_LOCATION_IS_LOADING:
      {
        var _isLoading = action.isLoading;
        return _objectSpread(_objectSpread({}, state), {}, {
          isLocationLoading: _isLoading
        });
      }

    case Types.SET_GRATUITY:
      {
        var payload = action.payload;
        return _objectSpread(_objectSpread({}, state), {}, {
          Gratuity: parseFloat(payload)
        });
      }

    case Types.RECEIVE_ORIGINAL_CHECK_DETAIL:
      {
        var check = action.check;
        return _objectSpread(_objectSpread({}, state), {}, {
          originalCheck: check
        });
      }

    case Types.RECEIVE_CHECK_DETAIL:
      {
        var _check = action.check;
        var orderId = undefined;

        try {
          var _state$code;

          orderId = parseInt(state.code1) + "-" + ((_state$code = state.code2) === null || _state$code === void 0 ? void 0 : _state$code.toLowerCase());
        } catch (error) {
          return _objectSpread(_objectSpread({}, state), {}, {
            isLoading: false,
            receipt: undefined
          });
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: false,
          check: _check,
          receipt: undefined,
          OrderId: orderId
        });
      }

    case Types.RECEIVE_LOCATION:
      {
        var location = action.location;
        return _objectSpread(_objectSpread({}, state), {}, {
          isLocationLoading: false,
          location: location
        });
      }

    case Types.PAY_ORDER_SUCCESS:
      {
        var _state$check;

        var receipt = action.receipt;
        return {
          // ...state,
          // check: state.check,
          isLoading: false,
          receipt: _objectSpread(_objectSpread({}, receipt), {}, {
            RedeemedRewards: (state === null || state === void 0 ? void 0 : (_state$check = state.check) === null || _state$check === void 0 ? void 0 : _state$check.RedeemedRewards) || 0
          }),
          Gratuity: 0.00,
          location: state === null || state === void 0 ? void 0 : state.location,
          paymentMethod: state === null || state === void 0 ? void 0 : state.paymentMethod
        };
      }

    case Types.SET_PAY_ORDER_PAYLOAD:
      {
        var _payload = action.payload;
        return _objectSpread(_objectSpread({}, state), {}, {
          payload: _payload
        });
      }

    case Types.SET_PAYMENT_METHOD:
      {
        var paymentMethod = action.paymentMethod;
        return _objectSpread(_objectSpread({}, state), {}, {
          paymentMethod: paymentMethod
        });
      }

    case Types.CLEAR_ORDER:
      {
        var _code = state.code1;
        var _code2 = state.code2;
        return _objectSpread(_objectSpread({}, INITIAL_STATE), {}, {
          code1: _code,
          code2: _code2
        });
      }

    case Types.RESET_CHECK:
      {
        if (!state.originalCheck) {
          return state;
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          check: state.originalCheck
        });
      }

    default:
      {
        return state;
      }
  }
};

export default mobilepayReducer;